import React from 'react';
import { Link } from 'react-router-dom';
import CTAButtonLink from '../CTA/CTAButtonLink.jsx'
import { BookOpen, MessageCircleWarning, Rocket } from 'lucide-react';
import '../Guides/guides.css';
import './home.css';
import Seo from "../Seo.jsx";
import mainConfig from "../../config/mainConfig"; // adjust the path as needed

import guardian from '../../logos/guardian.png'
import sun from '../../logos/TheSun.png'
import ft from '../../logos/ft.png'
import telegraph from '../../logos/telegraph.png'
import fbhigherodds from '../Guides/images/fbhigherodds.png';
import fb from './fb.png';
import mp from './mp.png';

const Home = () => {
  const meta = mainConfig.home?.seo || {};

  return (
    <div className="home-wrapper">
             <Seo title={meta.title} description={meta.description} url={meta.route}/>

      {/* HERO / BANNER SECTION */}
      <section className="hero">
        <div className="hero-inner">
          <h1><strong className='pink'>You</strong> can make money online with matched betting</h1>
          <h3>
            Brilliantly simple guides for absolute beginners. <strong>Free forever.</strong>
          </h3>
          <Link to="/get-started/step1" className="nav-link start-button">
            <Rocket size={20} style={{ marginRight: "8px" }} />
            <p>Start here</p>
          </Link>
        
        </div>
        <div className="rocket-background">
        <Rocket size={200} style={{ opacity: 0.1 }} />
      </div>
      </section>


      {/* LEARN FAST SECTION */}
      <section className="section learn-fast alt-bg">
        <div className="content-limited">
          <h2 className='title-text'>No Gambling. Just Maths.</h2>
          <div className="inline-grid">
            <div>
              <h3>Learn how to make...</h3>
              <p className="stat">£700+</p>
              <p className="statinfo">in welcome offers from bookies.</p>
              <p className="stat">£300-£1,000</p>
              <p className="statinfo">every month.</p>

            </div>
            <div className="image-container">
            <p>All with the help of the ultimate matched betting tools and guides.</p>

            <img src={fbhigherodds} alt="odds converter for matched betting" className="image image-1" />
            <img src={fb} alt="Oddsmatcher for OddsMonkey for for matched betting" className="image image-2" />
            <img src={mp} alt="Free bet calculators" className="image image-3" />
          </div>
        </div>
        </div>
      </section>

      <section className="section difference">
        <div className="content-limited">
          <h2 className='title-text'>A Second Income From Your Sofa.</h2>
        <div className="inline-triple">
          <div>
            <p className="stat">Wherever.</p>
            <p className="statinfo">On your commute. From your sofa. Matched bet from anywhere.</p>
          </div>
          <div>
            <p className="stat">Whenever.</p>
            <p className="statinfo">Flexible around your job. Or your family. Do as much or as little as you want.</p>
          </div>
          <div>
            <p className="stat">Get Faster.</p>
            <p className="statinfo">As you do more, you'll get quicker. More profit, less time.</p>
          </div>
        </div>

        </div>
      </section>


      <section className="cta-container">
        <div className="content-limited">
        <CTAButtonLink 
        to="/get-started/step1"
        text="Understand How Matched Betting Works in 180 Seconds"
        buttonText="Start now"
        icon={Rocket}
        tabText="Start Here"
      />
        </div>
      </section>



      {/* TOOLS SECTION */}
      <section className="section tools">
        <div className="content-limited-wide">
          <h2 className='title-text'>What first?</h2>
          <div className="inline-triple">
            <div className='content-container'>
              <p className='icon-lg'><Rocket/></p>
                <h2>Get me started</h2>
                <p>Understand what matched betting is, and how matched betting works, in less time than it takes to boil a kettle.</p>
                <a href="/get-started/step1" className="button secondary-cta">Start here →</a>
              </div>
              <div className='content-container'>
              <p className='icon-lg'><BookOpen/></p>
                <h2>Find a guide</h2>
                <p>Our awesome matched betting guides are organised so you can learn the right thing, at the right time.</p>
                <Link to="/guides" className="button secondary-cta">Let's Go →</Link>

              </div>
              <div className='content-container'>
              <p className='icon-lg'><MessageCircleWarning/></p>
                <h2>Learn about risks</h2>
                <p>People say it's risk-free. That's not completely true (though it's close). It's important to talk about it.</p>
                <Link to="/guides/matched-betting-risk-free-guide" className="button secondary-cta">Learn why →</Link>
                </div>
          </div>
        </div>
      </section>

            {/* TRUST BANNER */}
            <section className="trust-banner">
        <div className="content-limited">
        <p className="trust-text title-text">
            Everyone's talking about matched betting
          </p>
          <p className="trust-text mb-32">
It's in the press, including...
</p>
          <div className="trust-logos">
            <img src={guardian} alt="Financial Times" />
            <img src={ft} alt="The Guardian" />
            <img src={telegraph} alt="Trusted Logo 3" />
            <img src={sun} alt="Trusted Logo 4" />
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
